<template>
  <div class="flex flex-col xl:w-[1000px] my-6 p-1 gap-1 bg-slate-100">
    <slot />
  </div>
</template>
